import React from 'react';
import MarkdownView from 'react-showdown';

const Title = ({ title }) => {
  return <MarkdownView markdown={title} className="before-starting-title" />;
};

export default Title;
